import * as React from "react";
import PrepareScenarioScreen from "./PrepareScenarioScreen";

const screens = {
  M1: {
    module: "M1",
    backgroundImage: "/scenarioBgs/blackout.png",
    titleEn: "Stay at Home",
    titleDe: "Länger zu Hause bleiben",
    scenarioEn: "Blackout. Water is unstable. No shops, no delivery. Stay home for 72 hours with what you already have.",
    scenarioDe: "Blackout. Wasser ist unsicher. Keine Geschäfte, keine Lieferung. Bleibe 72 Stunden mit dem zu Hause, was du bereits hast.",
    taskEn: "72-hour supply shelf: select up to 10 items from electricity, food/water, safety, medical and mental-stability categories.",
    taskDe: "72-Stunden-Vorratsregal: Wähle bis zu 10 Dinge aus Strom, Nahrung/Wasser, Sicherheit, Medizin und mentaler Stabilität.",
  },
  M2: {
    module: "M2",
    backgroundImage: "/scenarioBgs/evacuation.png",
    titleEn: "60-Second Evacuation",
    titleDe: "Schnellweg / 60-Sekunden-Evakuierung",
    scenarioEn: "A threat is approaching. You have only 60 seconds to leave. Only the equipment that is already prepared and easy to access can help you.",
    scenarioDe: "Eine Bedrohung nähert sich. Du hast nur 60 Sekunden, um zu gehen. Nur Ausrüstung, die bereits vorbereitet und leicht erreichbar ist, kann dir helfen.",
    taskEn: "60-second backpack challenge: the timer starts and you must leave immediately. Select the essential items you would take with you and identify whether your emergency bag is ready.",
    taskDe: "60-Sekunden-Rucksack-Challenge: Der Timer startet und du musst sofort los. Wähle die wichtigsten Gegenstände aus, die du mitnehmen würdest, und prüfe, ob dein Notfallrucksack bereit ist.",
  },
  M3: {
    module: "M3",
    backgroundImage: "/scenarioBgs/secureDocs.png",
    titleEn: "Secure Documents",
    titleDe: "Dokumente sichern",
    scenarioEn: "You may not return home soon. Without documents, recovery becomes slower, expensive and harder to coordinate.",
    scenarioDe: "Du kommst vielleicht nicht schnell nach Hause zurück. Ohne Dokumente wird Wiederherstellung langsamer, teurer und schwerer koordinierbar.",
    taskEn: "Document sort: choose what belongs in the document bag from ID, insurance, residence permit, contracts, medication list, contacts and USB backup.",
    taskDe: "Dokumentensortierung: Wähle, was in die Dokumententasche gehört: Ausweis, Versicherung, Aufenthaltstitel, Verträge, Medikamentenliste, Kontakte und USB-Backup.",
  },
  M4: {
    module: "M4",
    backgroundImage: "/scenarioBgs/crisis.png",
    titleEn: "Evacuation & Shelter",
    titleDe: "Evakuierung & Unterkunft",
    scenarioEn: "You have a bag and documents. The next question is where to go and how to get there without normal infrastructure.",
    scenarioDe: "Du hast Rucksack und Dokumente. Die nächste Frage ist: Wohin gehst du und wie kommst du ohne normale Infrastruktur dorthin?",
    taskEn: "Local map exercise: mark first destination, backup destination, route without public transport and meeting point for family or colleagues.",
    taskDe: "Lokale Kartenübung: Markiere erstes Ziel, Ausweichziel, Route ohne öffentliche Verkehrsmittel und Treffpunkt für Familie oder Kolleg:innen.",
  },
  M5: {
    module: "M5",
    backgroundImage: "/scenarioBgs/recoveryPosition.png",
    titleEn: "Medical Aid",
    titleDe: "Medizinische Hilfe",
    scenarioEn: "A person is injured. Emergency services are delayed. You are the first available responder.",
    scenarioDe: "Eine Person ist verletzt. Rettungsdienste sind verzögert. Du bist die erste verfügbare helfende Person.",
    taskEn: "Dummy exercise: check response, call 112, check breathing, stop bleeding, use first-aid kit and recovery position.",
    taskDe: "Dummy-Übung: Reaktion prüfen, 112 rufen, Atmung prüfen, Blutung stoppen, Erste-Hilfe-Set nutzen und stabile Seitenlage.",
  },
  M6: {
    module: "M6",
    backgroundImage: "/scenarioBgs/commFailure.png",
    titleEn: "Communication",
    titleDe: "Kommunikation",
    scenarioEn: "A storm or outage has knocked out mobile networks. Battery remains, but calls and internet are unreliable.",
    scenarioDe: "Ein Sturm oder Ausfall hat Mobilfunknetze lahmgelegt. Akku ist noch da, aber Anrufe und Internet sind unzuverlässig.",
    taskEn: "Crank/battery radio task: find an official station or named official information source and identify where instructions would come from.",
    taskDe: "Kurbel-/Batterieradio-Aufgabe: Finde einen offiziellen Sender oder eine offizielle Informationsquelle und erkenne, wo Anweisungen herkommen würden.",
  },
  M7: {
    module: "M7",
    backgroundImage: "/scenarioBgs/mentalOverwhelm.png",
    titleEn: "Mental Resilience including Siren",
    titleDe: "Mentale Resilienz inklusive Sirene",
    scenarioEn: "The siren is sounding. You must decide while family asks for help, information is incomplete and the bag is not fully ready.",
    scenarioDe: "Die Sirene läuft. Du musst entscheiden, während Familie Hilfe braucht, Informationen unvollständig sind und der Rucksack nicht ganz bereit ist.",
    taskEn: "Pressure decision plus reset: name first priority, choose stay/go, send one short message, then complete box breathing.",
    taskDe: "Druckentscheidung plus Reset: Nenne die erste Priorität, wähle bleiben/gehen, sende eine kurze Nachricht und mache dann Box Breathing.",
  },
  M8: {
    module: "M8",
    backgroundImage: "/scenarioBgs/physicalLimit.png",
    titleEn: "Physical Resilience",
    titleDe: "Körperliche Resilienz",
    scenarioEn: "The elevator is unavailable and normal routes are blocked. You may need to move to safety while carrying your emergency backpack, a child, or essential supplies.",
    scenarioDe: "Der Aufzug ist nicht verfügbar und normale Wege sind blockiert. Du musst dich möglicherweise in Sicherheit bringen, während du deinen Notfallrucksack, ein Kind oder wichtige Vorräte trägst.",
    taskEn: "Emergency movement challenge: you need to leave the Lab building while carrying your backpack. Consider whether you could safely move, carry your equipment, and reach a safe location.",
    taskDe: "Notfall-Bewegungs-Challenge: Du musst das Lab-Gebäude verlassen, während du deinen Rucksack trägst. Überlege, ob du dich sicher bewegen, deine Ausrüstung tragen und einen sicheren Ort erreichen könntest.",
  },
};

export function PrepareScenarioM1(props: { handlePageChange: (page: string) => void }) {
  return <PrepareScenarioScreen {...props} copy={screens.M1} nextPage="VibeQuestions:prepare:M1" backPage="JourneyPillars" />;
}

export function PrepareScenarioM2(props: { handlePageChange: (page: string) => void }) {
  return <PrepareScenarioScreen {...props} copy={screens.M2} nextPage="VibeQuestions:prepare:M2" backPage="VibeQuestions:prepare:M1" />;
}

export function PrepareScenarioM3(props: { handlePageChange: (page: string) => void }) {
  return <PrepareScenarioScreen {...props} copy={screens.M3} nextPage="VibeQuestions:prepare:M3" backPage="VibeQuestions:prepare:M2" />;
}

export function PrepareScenarioM4(props: { handlePageChange: (page: string) => void }) {
  return <PrepareScenarioScreen {...props} copy={screens.M4} nextPage="VibeQuestions:prepare:M4" backPage="VibeQuestions:prepare:M3" />;
}

export function PrepareScenarioM5(props: { handlePageChange: (page: string) => void }) {
  return <PrepareScenarioScreen {...props} copy={screens.M5} nextPage="VibeQuestions:prepare:M5" backPage="VibeQuestions:prepare:M4" />;
}

export function PrepareScenarioM6(props: { handlePageChange: (page: string) => void }) {
  return <PrepareScenarioScreen {...props} copy={screens.M6} nextPage="VibeQuestions:prepare:M6" backPage="VibeQuestions:prepare:M5" />;
}

export function PrepareScenarioM7(props: { handlePageChange: (page: string) => void }) {
  return <PrepareScenarioScreen {...props} copy={screens.M7} nextPage="VibeQuestions:prepare:M7" backPage="VibeQuestions:prepare:M6" />;
}

export function PrepareScenarioM8(props: { handlePageChange: (page: string) => void }) {
  return <PrepareScenarioScreen {...props} copy={screens.M8} nextPage="VibeQuestions:prepare:M8" backPage="VibeQuestions:prepare:M7" />;
}
